module.exports = __webpack_public_path__ + "img/reportChicken_5.4a2e20eb.png";